import { render } from "./product-request-new.vue?vue&type=template&id=0a7122c7"
import script from "./product-request-new.vue?vue&type=script&lang=js"
export * from "./product-request-new.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__